export type CategoryId = string;

export interface TMItemCategoryResponse {
  id: CategoryId;
  title: string;
  fullName: string;
  description: string;
  parentId: string;
  markupFactor: string;
  range: string;
  hiPrice: string;
  loPrice: string;
}

export enum RangValue {
  squareFeet = 0,
  total = 1,
}

export const rangeValueItems = [RangValue.squareFeet, RangValue.total];
